import React, { FC } from "react";
import { Tooltip } from "antd";
import "./tool-tip.scss"

type ICustomTooltip = {
  toolTipvalue: any,
  children?: any
  overlayClassName ?: string
}

const CustomTooltip: FC<ICustomTooltip> = ({ toolTipvalue, children , overlayClassName = ''}) => {
  return (
    <Tooltip
      placement="top"
      title={toolTipvalue}
      overlayClassName={`table-tooltip ${overlayClassName}`}
    >
      {children || toolTipvalue}
    </Tooltip>
  );
};

export default CustomTooltip;
